export function getErrorLogJsonByteLength(value: unknown): number {
  const json = JSON.stringify(value);
  return typeof json === 'string' ? json.length : 0;
}
